import { fetchHelper } from '../../../api/api'
import { viewCourseLessonActions } from './viewCourseLessonSlice'

async function fetchTopicContents(topicId) {
    const response = await fetchHelper(
        `/Topiccontent/GetTopicContent/${topicId}`
    )
    const contents = response.data
    const contentsWithAttachments = await Promise.all(
        contents.map(async content => {
            let attachment = null
            if (content.contenttype === 'file')
                try {
                    const response = await fetchHelper(
                        `/Topiccontent/GetAttachment/${content.contentid}`
                    )
                    attachment = response.data
                } catch (error) {
                    // a 404/400 error means there is no attachment for this topic content
                    if (![404, 400].includes(error.response?.status)) {
                        // An actual error occured, rethrow it so the caller may handle it
                        throw error
                    }
                }
            return {
                ...content,
                attachment,
            }
        })
    )
    return contentsWithAttachments
}

export function getTopicContents(topicId) {
    return async dispatch => {
        dispatch(viewCourseLessonActions.getTopicContentsRequest())
        try {
            const contents = await fetchTopicContents(topicId)
            dispatch(
                viewCourseLessonActions.getTopicContentsRequestSuccess(contents)
            )
        } catch (error) {
            dispatch(
                viewCourseLessonActions.getTopicContentsRequestFailure(
                    error.response?.data?.message ?? error.message
                )
            )
        }
    }
}
